import { useEffect, useState } from 'react';
import { doGet } from '../../../../../services/http/httpHelper';
import { BasketResponseDTO } from './types';

export const getBasketQuestionnaire = async (
  productSapCode: number
): Promise<BasketResponseDTO | null> => {
  const resp = await doGet(`/basket/questionnaire/${productSapCode}`);

  if (Array.isArray(resp?.questions)) return resp as BasketResponseDTO;

  if (resp?.httpStatus) {
    const detail = resp.body?.message ?? resp.body?.error ?? '';
    throw new Error(
      `A API respondeu ${resp.httpStatus}${detail ? `: ${detail}` : ''}`
    );
  }

  return null;
};

type ApiQuestionnaireState =
  | { status: 'idle' | 'loading'; data: null; error: null }
  | { status: 'done'; data: BasketResponseDTO | null; error: null }
  | { status: 'error'; data: null; error: string };

const IDLE: ApiQuestionnaireState = { status: 'idle', data: null, error: null };

/** Busca o questionário do produto. Sem `productSapCode`, fica parado. */
export const useApiQuestionnaire = (productSapCode: number | undefined) => {
  const [state, setState] = useState<ApiQuestionnaireState>(IDLE);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (productSapCode === undefined) {
      setState(IDLE);
      return;
    }

    let cancelled = false;
    setState({ status: 'loading', data: null, error: null });
    getBasketQuestionnaire(productSapCode).then(
      (data) => {
        if (!cancelled) setState({ status: 'done', data, error: null });
      },
      (error: unknown) => {
        if (cancelled) return;
        const message = error instanceof Error ? error.message : String(error);
        setState({ status: 'error', data: null, error: message });
      }
    );

    return () => {
      cancelled = true;
    };
  }, [productSapCode, attempt]);

  return { ...state, retry: () => setAttempt((n) => n + 1) };
};
